import { ProductPageSection } from "./ProductPageSection";
import { SimpleGrid, Divider } from "@chakra-ui/react";
import { FeatureCard } from "components/molecules/FeatureCard";
import { IProduct } from "interfaces/product.interface";
import { IProductFeature } from "interfaces/product-feature.interface";

export const ProductPageFeatures = ({ product }: { product: IProduct }) => {
  const { features } = product;

  return (
    <ProductPageSection title="Features" id="features">
      <SimpleGrid columns={{ base: 1, lg: 2 }} spacing={10}>
        {features &&
          features.map((feature: IProductFeature, i: number) => {
            return (
              <FeatureCard
                key={i}
                title={feature.title}
                body={feature.content}
                color={product.color}
              />
            );
          })}
      </SimpleGrid>
    </ProductPageSection>
  );
};
